import { Button } from "components/DesignSystem/Button/Button";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { useDispatch } from "react-redux";
import ChatInfoSmallRedirect from "static/images/ChatInfoSmallRedirect.svg";
import ChatTicketIcon from "static/images/ChatTicketIcon.svg";
import { chatApi, useCreateMessageDraftMutation } from "store/apis/chat";
import { MessageResponse } from "stream-chat";
import { useChatContext } from "stream-chat-react";
import { DefaultStreamChatGenerics } from "stream-chat-react/dist/types/types";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";
import { BackendError } from "types/utils/error";
import { openLink } from "utils/openLink";

export const ChatTicketCard = ({
  title,
  description,
  ticketId,
  resolved,
  channelUrl,
}: {
  title: string;
  description: string;
  ticketId: string;
  resolved?: boolean;
  channelUrl: string;
}) => {
  const { isCustomer } = useRoleBasedView();
  const [createUpdateDraft, { isLoading }] = useCreateMessageDraftMutation();
  const dispatch = useDispatch();
  const { alertToast } = useToast();

  const handleFollowUp = async () => {
    try {
      const messageData = await createUpdateDraft({
        channelUrl,
        message: `Following up on this, any updates?`,
      });

      if (messageData.data) {
        dispatch(
          chatApi.util.upsertQueryData(
            "getDraftMessage",
            { channelUrl },
            messageData.data
          )
        );
      }
    } catch (error) {
      alertToast({ message: (error as BackendError).data?.error?.message });
    }
  };

  return (
    <div className="t-flex t-items-center t-justify-between t-gap-2">
      <div className="t-flex t-gap-2 t-items-center">
        <div className="t-relative t-min-h-8 t-min-w-8 t-max-h-8 t-max-w-8 t-border t-border-solid t-border-neutral-0 t-rounded-full t-flex t-items-center t-justify-center">
          <img src={ChatTicketIcon} alt="ChatTicketIcon" />
        </div>
        <div>
          <div
            className="t-flex t-items-center t-text-subtext-sm t-text-text-100"
            role="button"
            onClick={() =>
              isCustomer
                ? openLink(`/settings/tickets?ticketUuid=${ticketId}`)
                : openLink(`/admin/tickets?ticketUuid=${ticketId}`)
            }
          >
            <div className="t-line-clamp-1">{title}</div>
            &nbsp;
            <img src={ChatInfoSmallRedirect} alt="ChatInfoSmallRedirect" />
          </div>
          <div className="t-text-caption t-text-text-30 t-line-clamp-1">
            {description}
          </div>
        </div>
      </div>
      <div className="t-max-w-fit">
        <Button size="small" onClick={handleFollowUp}>
          {resolved ? "View" : "Follow up"}
        </Button>
      </div>
    </div>
  );
};
